import { useTheme } from '@/app/providers';
import { NotificationBell } from '@/core/ui/components';
import { GlobalSearchBar } from '@/presentation/components/organisms/admin-v2/GlobalSearchBar';
import { useI18n } from '@/shared/i18n';
import { ActiveSectionSwitcher } from '@/modules/sections/ui/components/ActiveSectionSwitcher';
import { Moon, Sparkles, Sun } from 'lucide-react';

export function Topbar() {
  const { isDark, toggleTheme } = useTheme();
  const { t, language, setLanguage } = useI18n();

  return (
    <header className="flex items-center gap-3 px-6 py-3 border-b border-theme-light bg-theme sticky top-0 z-10 min-h-[60px]">
      {/* Search bar — center */}
      <div className="flex-1 max-w-[480px] mx-auto">
        <GlobalSearchBar />
      </div>

      {/* Right: actions */}
      <div className="flex items-center gap-1.5 flex-shrink-0 ml-auto">
        <ActiveSectionSwitcher />

        {/* Hommi AI */}
        <button className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl bg-gradient-to-r from-violet-500 to-purple-600 text-white text-xs font-semibold hover:opacity-90 transition-opacity shadow-sm shadow-purple-500/25">
          <Sparkles size={13} />
          {/* <span className="hidden sm:inline">Hommi AI</span> */}
        </button>

        <NotificationBell />

        <button
          onClick={toggleTheme}
          className="p-2 rounded-lg hover:bg-surface-secondary transition-colors"
          aria-label={isDark ? t('settings.lightMode') : t('settings.darkMode')}
        >
          {isDark
            ? <Sun size={18} className="text-yellow-400" />
            : <Moon size={18} className="text-theme-secondary" />}
        </button>

        {/* Language toggle */}
        <div className="flex items-center gap-0.5 bg-surface-secondary rounded-lg p-0.5 border border-theme-light">
          {(['es', 'en'] as const).map((lang) => (
            <button
              key={lang}
              onClick={() => setLanguage(lang)}
              className={`px-2.5 py-1 text-[10px] font-bold rounded-md transition-all ${
                language === lang
                  ? 'bg-primary-600 text-white'
                  : 'text-theme-secondary hover:text-theme'
              }`}
            >
              {lang.toUpperCase()}
            </button>
          ))}
        </div>
      </div>
    </header>
  );
}
